/*
 * File: PaidUserSignUpStep.styles.js
 * Project: lets-talk-web
 *
 * Created by Morgan Rivera on April 3, 2026 at 1:25 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	max-width: 550px;
	margin: 0px auto;
	padding-bottom: 10px;

	.cardPadding {
		padding: 50px;
	}
	h2 {
		text-align: center;
		margin: 10px 0px 10px;
	}
	p {
		text-align: center;
   		margin-bottom: 40px;
		color: ${({ theme }) => theme.secondaryText};
	}
	& > p {
		margin-bottom: 40px;
	}
	& > button {
		margin-top: 30px;
	}
	button {
		width: 100%;
	}
`;

export const BottomActionContainer = styled.div`
	margin: 14px 0px 2px;
    text-align: center;
    width: 100%;

	button {
		padding: 0px;
		display: inline-block;
		width: auto;
	}
	p {
		margin: 0px;
		display: inline-block;

		span {
			font-size: inherit !important;
			color: ${({ theme }) => theme.brandPrimaryBase};
		}
	}
`;

export const CheckboxRow = styled.div`
	display: flex;
	margin: 20px 0 0 0;
	align-items: center;

	span {
		flex-grow: 1;
		text-align: left;
		margin: 0 0 0 12px;
		position: relative;
		top: -1px;
		color: ${({ theme }) => theme.secondaryText};

		a,
		a:link,
		a:visited {
			color: inherit;
		}
	}
`;


export const CheckboxContainer = styled.div`
	margin: 20px 0px 35px;
`;
